/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CodeSearch200Response } from '../models';
// @ts-ignore
import type { CodeSetDetailTenantMetadata } from '../models';
// @ts-ignore
import type { CodeSetDetailedSearch } from '../models';
// @ts-ignore
import type { CodeSetDocuments } from '../models';
// @ts-ignore
import type { CodeSetDocumentsResponse } from '../models';
// @ts-ignore
import type { CodeSetSearch } from '../models';
// @ts-ignore
import type { CodeSetSystem } from '../models';
// @ts-ignore
import type { CodeSuggestions200Response } from '../models';
// @ts-ignore
import type { CodeSummaryResponse } from '../models';
// @ts-ignore
import type { CodeSummarySearchItem } from '../models';
// @ts-ignore
import type { CodeWithHierarchy } from '../models';
// @ts-ignore
import type { GetCodeRelations200Response } from '../models';
// @ts-ignore
import type { GetStaticCodes200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * CodeExplorerApi - axios parameter creator
 * @export
 */
export const CodeExplorerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get code details
         * @summary Code Explorer Post Detailed Proxy
         * @param {CodeSetDetailedSearch} codeSetDetailedSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeDetail: async (codeSetDetailedSearch: CodeSetDetailedSearch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeSetDetailedSearch' is not null or undefined
            assertParamExists('codeDetail', 'codeSetDetailedSearch', codeSetDetailedSearch)
            const localVarPath = `/api/v1/ce/code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(codeSetDetailedSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get code hierarchy
         * @summary Code Explorer Get Hierarchy Proxy
         * @param {string} codeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeHierarchy: async (codeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('codeHierarchy', 'codeId', codeId)
            const localVarPath = `/api/v1/ce/code/hierarchy/{codeId}`
                .replace(`{${"codeId"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get code search
         * @summary Code Explorer Post Search Proxy
         * @param {CodeSetSearch} codeSetSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeSearch: async (codeSetSearch: CodeSetSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeSetSearch' is not null or undefined
            assertParamExists('codeSearch', 'codeSetSearch', codeSetSearch)
            const localVarPath = `/api/v1/ce/code/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(codeSetSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get code suggestions
         * @summary Code Explorer Post Suggestions Proxy
         * @param {CodeSetSearch} codeSetSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeSuggestions: async (codeSetSearch: CodeSetSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeSetSearch' is not null or undefined
            assertParamExists('codeSuggestions', 'codeSetSearch', codeSetSearch)
            const localVarPath = `/api/v1/ce/code/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(codeSetSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get code search summary
         * @summary Code Explorer Post Summary Proxy
         * @param {Array<CodeSummarySearchItem>} codeSummarySearchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeSummary: async (codeSummarySearchItem: Array<CodeSummarySearchItem>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeSummarySearchItem' is not null or undefined
            assertParamExists('codeSummary', 'codeSummarySearchItem', codeSummarySearchItem)
            const localVarPath = `/api/v1/ce/code/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(codeSummarySearchItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get code relations
         * @summary Code Explorer Get Code Relations Proxy
         * @param {string} codeId 
         * @param {string} [searchterm] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeRelations: async (codeId: string, searchterm?: string, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('getCodeRelations', 'codeId', codeId)
            const localVarPath = `/api/v1/ce/code/relation/{codeId}`
                .replace(`{${"codeId"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (searchterm !== undefined) {
                localVarQueryParameter['searchterm'] = searchterm;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get codeset document
         * @summary Code Explorer Get Codeset Document Proxy
         * @param {CodeSetSystem} codesetsystem 
         * @param {CodeSetDocuments} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodesetDocumentPresignedUrl: async (codesetsystem: CodeSetSystem, document: CodeSetDocuments, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codesetsystem' is not null or undefined
            assertParamExists('getCodesetDocumentPresignedUrl', 'codesetsystem', codesetsystem)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('getCodesetDocumentPresignedUrl', 'document', document)
            const localVarPath = `/api/v1/ce/getCodesetDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (codesetsystem !== undefined) {
                localVarQueryParameter['codesetsystem'] = codesetsystem;
            }

            if (document !== undefined) {
                localVarQueryParameter['document'] = document;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the static codes
         * @summary Code Explorer Get Static Codes Proxy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticCodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ce/code/staticcodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodeExplorerApi - functional programming interface
 * @export
 */
export const CodeExplorerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CodeExplorerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get code details
         * @summary Code Explorer Post Detailed Proxy
         * @param {CodeSetDetailedSearch} codeSetDetailedSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codeDetail(codeSetDetailedSearch: CodeSetDetailedSearch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeSetDetailTenantMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codeDetail(codeSetDetailedSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerApi.codeDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get code hierarchy
         * @summary Code Explorer Get Hierarchy Proxy
         * @param {string} codeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codeHierarchy(codeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeWithHierarchy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codeHierarchy(codeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerApi.codeHierarchy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get code search
         * @summary Code Explorer Post Search Proxy
         * @param {CodeSetSearch} codeSetSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codeSearch(codeSetSearch: CodeSetSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeSearch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codeSearch(codeSetSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerApi.codeSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get code suggestions
         * @summary Code Explorer Post Suggestions Proxy
         * @param {CodeSetSearch} codeSetSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codeSuggestions(codeSetSearch: CodeSetSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeSuggestions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codeSuggestions(codeSetSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerApi.codeSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get code search summary
         * @summary Code Explorer Post Summary Proxy
         * @param {Array<CodeSummarySearchItem>} codeSummarySearchItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codeSummary(codeSummarySearchItem: Array<CodeSummarySearchItem>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codeSummary(codeSummarySearchItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerApi.codeSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get code relations
         * @summary Code Explorer Get Code Relations Proxy
         * @param {string} codeId 
         * @param {string} [searchterm] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCodeRelations(codeId: string, searchterm?: string, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCodeRelations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCodeRelations(codeId, searchterm, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerApi.getCodeRelations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get codeset document
         * @summary Code Explorer Get Codeset Document Proxy
         * @param {CodeSetSystem} codesetsystem 
         * @param {CodeSetDocuments} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCodesetDocumentPresignedUrl(codesetsystem: CodeSetSystem, document: CodeSetDocuments, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeSetDocumentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCodesetDocumentPresignedUrl(codesetsystem, document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerApi.getCodesetDocumentPresignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all the static codes
         * @summary Code Explorer Get Static Codes Proxy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaticCodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStaticCodes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaticCodes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeExplorerApi.getStaticCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CodeExplorerApi - factory interface
 * @export
 */
export const CodeExplorerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CodeExplorerApiFp(configuration)
    return {
        /**
         * Get code details
         * @summary Code Explorer Post Detailed Proxy
         * @param {CodeExplorerApiCodeDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeDetail(requestParameters: CodeExplorerApiCodeDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSetDetailTenantMetadata> {
            return localVarFp.codeDetail(requestParameters.codeSetDetailedSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get code hierarchy
         * @summary Code Explorer Get Hierarchy Proxy
         * @param {CodeExplorerApiCodeHierarchyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeHierarchy(requestParameters: CodeExplorerApiCodeHierarchyRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeWithHierarchy> {
            return localVarFp.codeHierarchy(requestParameters.codeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get code search
         * @summary Code Explorer Post Search Proxy
         * @param {CodeExplorerApiCodeSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeSearch(requestParameters: CodeExplorerApiCodeSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSearch200Response> {
            return localVarFp.codeSearch(requestParameters.codeSetSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get code suggestions
         * @summary Code Explorer Post Suggestions Proxy
         * @param {CodeExplorerApiCodeSuggestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeSuggestions(requestParameters: CodeExplorerApiCodeSuggestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSuggestions200Response> {
            return localVarFp.codeSuggestions(requestParameters.codeSetSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get code search summary
         * @summary Code Explorer Post Summary Proxy
         * @param {CodeExplorerApiCodeSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codeSummary(requestParameters: CodeExplorerApiCodeSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSummaryResponse> {
            return localVarFp.codeSummary(requestParameters.codeSummarySearchItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Get code relations
         * @summary Code Explorer Get Code Relations Proxy
         * @param {CodeExplorerApiGetCodeRelationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeRelations(requestParameters: CodeExplorerApiGetCodeRelationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCodeRelations200Response> {
            return localVarFp.getCodeRelations(requestParameters.codeId, requestParameters.searchterm, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Get codeset document
         * @summary Code Explorer Get Codeset Document Proxy
         * @param {CodeExplorerApiGetCodesetDocumentPresignedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodesetDocumentPresignedUrl(requestParameters: CodeExplorerApiGetCodesetDocumentPresignedUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSetDocumentsResponse> {
            return localVarFp.getCodesetDocumentPresignedUrl(requestParameters.codesetsystem, requestParameters.document, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the static codes
         * @summary Code Explorer Get Static Codes Proxy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticCodes(options?: RawAxiosRequestConfig): AxiosPromise<GetStaticCodes200Response> {
            return localVarFp.getStaticCodes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CodeExplorerApi - interface
 * @export
 * @interface CodeExplorerApi
 */
export interface CodeExplorerApiInterface {
    /**
     * Get code details
     * @summary Code Explorer Post Detailed Proxy
     * @param {CodeExplorerApiCodeDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApiInterface
     */
    codeDetail(requestParameters: CodeExplorerApiCodeDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSetDetailTenantMetadata>;

    /**
     * Get code hierarchy
     * @summary Code Explorer Get Hierarchy Proxy
     * @param {CodeExplorerApiCodeHierarchyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApiInterface
     */
    codeHierarchy(requestParameters: CodeExplorerApiCodeHierarchyRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeWithHierarchy>;

    /**
     * Get code search
     * @summary Code Explorer Post Search Proxy
     * @param {CodeExplorerApiCodeSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApiInterface
     */
    codeSearch(requestParameters: CodeExplorerApiCodeSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSearch200Response>;

    /**
     * Get code suggestions
     * @summary Code Explorer Post Suggestions Proxy
     * @param {CodeExplorerApiCodeSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApiInterface
     */
    codeSuggestions(requestParameters: CodeExplorerApiCodeSuggestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSuggestions200Response>;

    /**
     * Get code search summary
     * @summary Code Explorer Post Summary Proxy
     * @param {CodeExplorerApiCodeSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApiInterface
     */
    codeSummary(requestParameters: CodeExplorerApiCodeSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSummaryResponse>;

    /**
     * Get code relations
     * @summary Code Explorer Get Code Relations Proxy
     * @param {CodeExplorerApiGetCodeRelationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApiInterface
     */
    getCodeRelations(requestParameters: CodeExplorerApiGetCodeRelationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCodeRelations200Response>;

    /**
     * Get codeset document
     * @summary Code Explorer Get Codeset Document Proxy
     * @param {CodeExplorerApiGetCodesetDocumentPresignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApiInterface
     */
    getCodesetDocumentPresignedUrl(requestParameters: CodeExplorerApiGetCodesetDocumentPresignedUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<CodeSetDocumentsResponse>;

    /**
     * Get all the static codes
     * @summary Code Explorer Get Static Codes Proxy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApiInterface
     */
    getStaticCodes(options?: RawAxiosRequestConfig): AxiosPromise<GetStaticCodes200Response>;

}

/**
 * Request parameters for codeDetail operation in CodeExplorerApi.
 * @export
 * @interface CodeExplorerApiCodeDetailRequest
 */
export interface CodeExplorerApiCodeDetailRequest {
    /**
     * 
     * @type {CodeSetDetailedSearch}
     * @memberof CodeExplorerApiCodeDetail
     */
    readonly codeSetDetailedSearch: CodeSetDetailedSearch
}

/**
 * Request parameters for codeHierarchy operation in CodeExplorerApi.
 * @export
 * @interface CodeExplorerApiCodeHierarchyRequest
 */
export interface CodeExplorerApiCodeHierarchyRequest {
    /**
     * 
     * @type {string}
     * @memberof CodeExplorerApiCodeHierarchy
     */
    readonly codeId: string
}

/**
 * Request parameters for codeSearch operation in CodeExplorerApi.
 * @export
 * @interface CodeExplorerApiCodeSearchRequest
 */
export interface CodeExplorerApiCodeSearchRequest {
    /**
     * 
     * @type {CodeSetSearch}
     * @memberof CodeExplorerApiCodeSearch
     */
    readonly codeSetSearch: CodeSetSearch

    /**
     * 
     * @type {number}
     * @memberof CodeExplorerApiCodeSearch
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof CodeExplorerApiCodeSearch
     */
    readonly pgSize?: number
}

/**
 * Request parameters for codeSuggestions operation in CodeExplorerApi.
 * @export
 * @interface CodeExplorerApiCodeSuggestionsRequest
 */
export interface CodeExplorerApiCodeSuggestionsRequest {
    /**
     * 
     * @type {CodeSetSearch}
     * @memberof CodeExplorerApiCodeSuggestions
     */
    readonly codeSetSearch: CodeSetSearch

    /**
     * 
     * @type {number}
     * @memberof CodeExplorerApiCodeSuggestions
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof CodeExplorerApiCodeSuggestions
     */
    readonly pgSize?: number
}

/**
 * Request parameters for codeSummary operation in CodeExplorerApi.
 * @export
 * @interface CodeExplorerApiCodeSummaryRequest
 */
export interface CodeExplorerApiCodeSummaryRequest {
    /**
     * 
     * @type {Array<CodeSummarySearchItem>}
     * @memberof CodeExplorerApiCodeSummary
     */
    readonly codeSummarySearchItem: Array<CodeSummarySearchItem>
}

/**
 * Request parameters for getCodeRelations operation in CodeExplorerApi.
 * @export
 * @interface CodeExplorerApiGetCodeRelationsRequest
 */
export interface CodeExplorerApiGetCodeRelationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CodeExplorerApiGetCodeRelations
     */
    readonly codeId: string

    /**
     * 
     * @type {string}
     * @memberof CodeExplorerApiGetCodeRelations
     */
    readonly searchterm?: string

    /**
     * 
     * @type {number}
     * @memberof CodeExplorerApiGetCodeRelations
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof CodeExplorerApiGetCodeRelations
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getCodesetDocumentPresignedUrl operation in CodeExplorerApi.
 * @export
 * @interface CodeExplorerApiGetCodesetDocumentPresignedUrlRequest
 */
export interface CodeExplorerApiGetCodesetDocumentPresignedUrlRequest {
    /**
     * 
     * @type {CodeSetSystem}
     * @memberof CodeExplorerApiGetCodesetDocumentPresignedUrl
     */
    readonly codesetsystem: CodeSetSystem

    /**
     * 
     * @type {CodeSetDocuments}
     * @memberof CodeExplorerApiGetCodesetDocumentPresignedUrl
     */
    readonly document: CodeSetDocuments
}

/**
 * CodeExplorerApi - object-oriented interface
 * @export
 * @class CodeExplorerApi
 * @extends {BaseAPI}
 */
export class CodeExplorerApi extends BaseAPI implements CodeExplorerApiInterface {
    /**
     * Get code details
     * @summary Code Explorer Post Detailed Proxy
     * @param {CodeExplorerApiCodeDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApi
     */
    public codeDetail(requestParameters: CodeExplorerApiCodeDetailRequest, options?: RawAxiosRequestConfig) {
        return CodeExplorerApiFp(this.configuration).codeDetail(requestParameters.codeSetDetailedSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get code hierarchy
     * @summary Code Explorer Get Hierarchy Proxy
     * @param {CodeExplorerApiCodeHierarchyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApi
     */
    public codeHierarchy(requestParameters: CodeExplorerApiCodeHierarchyRequest, options?: RawAxiosRequestConfig) {
        return CodeExplorerApiFp(this.configuration).codeHierarchy(requestParameters.codeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get code search
     * @summary Code Explorer Post Search Proxy
     * @param {CodeExplorerApiCodeSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApi
     */
    public codeSearch(requestParameters: CodeExplorerApiCodeSearchRequest, options?: RawAxiosRequestConfig) {
        return CodeExplorerApiFp(this.configuration).codeSearch(requestParameters.codeSetSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get code suggestions
     * @summary Code Explorer Post Suggestions Proxy
     * @param {CodeExplorerApiCodeSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApi
     */
    public codeSuggestions(requestParameters: CodeExplorerApiCodeSuggestionsRequest, options?: RawAxiosRequestConfig) {
        return CodeExplorerApiFp(this.configuration).codeSuggestions(requestParameters.codeSetSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get code search summary
     * @summary Code Explorer Post Summary Proxy
     * @param {CodeExplorerApiCodeSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApi
     */
    public codeSummary(requestParameters: CodeExplorerApiCodeSummaryRequest, options?: RawAxiosRequestConfig) {
        return CodeExplorerApiFp(this.configuration).codeSummary(requestParameters.codeSummarySearchItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get code relations
     * @summary Code Explorer Get Code Relations Proxy
     * @param {CodeExplorerApiGetCodeRelationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApi
     */
    public getCodeRelations(requestParameters: CodeExplorerApiGetCodeRelationsRequest, options?: RawAxiosRequestConfig) {
        return CodeExplorerApiFp(this.configuration).getCodeRelations(requestParameters.codeId, requestParameters.searchterm, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get codeset document
     * @summary Code Explorer Get Codeset Document Proxy
     * @param {CodeExplorerApiGetCodesetDocumentPresignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApi
     */
    public getCodesetDocumentPresignedUrl(requestParameters: CodeExplorerApiGetCodesetDocumentPresignedUrlRequest, options?: RawAxiosRequestConfig) {
        return CodeExplorerApiFp(this.configuration).getCodesetDocumentPresignedUrl(requestParameters.codesetsystem, requestParameters.document, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the static codes
     * @summary Code Explorer Get Static Codes Proxy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeExplorerApi
     */
    public getStaticCodes(options?: RawAxiosRequestConfig) {
        return CodeExplorerApiFp(this.configuration).getStaticCodes(options).then((request) => request(this.axios, this.basePath));
    }
}

